export default __webpack_public_path__ + "static/media/Nav-Download.fb5bc83a.svg";